<div class="announcement-container" *ngIf="announcement">
  <div class="announcement-header">
    <svg class="announcement-icon" width="20" height="20" viewBox="0 0 20 20">
      <use xlink:href="assets/icon/svg-icon-def.svg#announcement"></use>
    </svg>
    <span translate [translateParams]="{ customerType: getTranslatedCustomerType() }" class="text-capitalize">
      dashboard.announcementFromMy
    </span>
  </div>
  <div class="announcement-title">{{ announcement.Title }}</div>
  <div class="announcement-content" [innerHTML]="announcement.Content" (click)="onAnnouncementContentClick($event)"></div>
  
  <div class="announcement-footer" *ngIf="shouldShowConsent()">
    <div class="consent-text" translate [translateParams]="{ customerType: getTranslatedCustomerType() }">
      dashboard.consentText
    </div>
    <div class="consent-options">
      <mat-checkbox 
        [(ngModel)]="userConsent" 
        (click)="onConsentChange()"
        class="consent-checkbox">
        <span translate>dashboard.consentOptions.consent</span>
      </mat-checkbox>
      <mat-checkbox 
        [(ngModel)]="userDecline" 
        (click)="onDeclineChange()"
        class="consent-checkbox">
        <span translate>dashboard.consentOptions.decline</span>
      </mat-checkbox>
    </div>
    <button 
      class="app-c-btn app-c-btn--primary app-c-btn--curve" 
      [disabled]="!userConsent && !userDecline"
      (click)="onSaveConsent()">
      <span translate>dashboard.consentOptions.save</span>
    </button>
  </div>
</div>
